import { Box, Flex, Stack } from '@chakra-ui/react';
import { TextS, TextXS } from '../Text/Index';
import { ReactNode } from 'react';
import ProofLocationButton from '../PDFs/DownloadPDFButton/proofLocationButton';
import { IProofLocationSpecialCompetitionProps } from '../../services/hooks/ProofLocation/useGetProofLocationSpecialResultCompetition';

interface IOwnProps {
  proofLocationData: IProofLocationSpecialCompetitionProps | undefined;
  boxDisplay: string[];
  boxGap: string[];
  widhtLabel: string[];
  showDownloadButton?: boolean;
}

const ProofLocationCard: React.FC<IOwnProps> = ({
  proofLocationData,
  boxDisplay,
  boxGap,
  widhtLabel,
  showDownloadButton = true,
}) => {
  // function subtrairDiaUltimoUtil(dataStr: string) {
  //   const [dia, mes, ano] = dataStr.split('/').map(Number);
  //   const data = new Date(ano, mes - 1, dia);
  //   data.setDate(data.getDate() - 1);
  //   const novoDia = String(data.getDate()).padStart(2, '0');
  //   const novoMes = String(data.getMonth() + 1).padStart(2, '0');
  //   const novoAno = data.getFullYear();
  //   return `${novoDia}/${novoMes}/${novoAno}`;
  // }

  return (
    <Box h="100%" mb={10}>
      {proofLocationData ? (
        <>
          <Stack p={'20px'} align="center">
            <TextS fontWeight="bold">CARTÃO DE CONVOCAÇÃO DE PROVA</TextS>
            {proofLocationData?.step_title && (
              <TextS fontWeight="bold">{proofLocationData?.step_title.toUpperCase()}</TextS>
            )}

            <TextS fontWeight="bold">{proofLocationData?.notice_name}</TextS>
          </Stack>
          <Stack px={[2, 2, 2, 10, 10]} gap={5}>
            <Section title="DADOS DO(A) CANDIDATO(A)">
              <DataField
                label="INSCRIÇÃO:"
                value={proofLocationData?.registration_code}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label={proofLocationData?.is_cultural_house ? 'TURMA:' : 'VAGA:'}
                value={proofLocationData?.first_vacancy?.toUpperCase()}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              {proofLocationData?.second_vacancy && (
                <DataField
                  label="SEGUNDA OPÇÃO:"
                  value={proofLocationData?.second_vacancy}
                  {...{ boxDisplay, boxGap, widhtLabel }}
                />
              )}
              <DataField
                label="NOME COMPLETO:"
                value={proofLocationData?.candidate.candidate_name?.toUpperCase()}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label="CPF:"
                value={proofLocationData?.candidate.cpf}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label="DOCUMENTO:"
                value={`${proofLocationData?.candidate.document_type}: ${proofLocationData?.candidate.document_number}`}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label="DATA DE NASCIMENTO:"
                value={proofLocationData?.candidate.date_of_birth}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label="ENDEREÇO:"
                value={proofLocationData?.candidate.candidate_address?.toUpperCase()}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label="TELEFONE CELULAR:"
                value={proofLocationData?.candidate.cellphone}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
            </Section>

            <Section title="DADOS PARA REALIZAÇÃO DA PROVA">
              <DataField
                label="LOCAL DE PROVA:"
                value={proofLocationData?.candidate_allocation.test_site_name}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label="SALA:"
                value={`${proofLocationData?.candidate_allocation.test_room_name} ${proofLocationData.candidate_allocation.details ? `(${proofLocationData?.candidate_allocation.details})` : ''}`}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label="ENDEREÇO:"
                value={proofLocationData?.candidate_allocation.test_site_address?.toUpperCase()}
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              <DataField
                label="DATA DA PROVA:"
                value={
                  proofLocationData.exam_schedule.exam_schedule_date ||
                  proofLocationData?.candidate_allocation.test_date
                }
                {...{ boxDisplay, boxGap, widhtLabel }}
              />
              {(proofLocationData.has_exam_schedule && (
                <>
                  <DataField
                    label="INICIO DA PROVA:"
                    value={`${proofLocationData?.exam_schedule.exam_schedule_start_time}h`}
                    {...{ boxDisplay, boxGap, widhtLabel }}
                  />
                  {/* <DataField
                    label="DATA E HORA DO SORTEIO DO PONTO:"
                    value={`${proofLocationData?.exam_schedule.exam_schedule_date ? subtrairDiaUltimoUtil(proofLocationData?.exam_schedule.exam_schedule_date) : '--'} ${proofLocationData?.exam_schedule.exam_schedule_start_time || '--'}H`}
                    {...{ boxDisplay, boxGap, widhtLabel }}
                  /> */}
                </>
              )) || (
                <>
                  <DataField
                    label="HORA DA PROVA:"
                    value={`${proofLocationData?.candidate_allocation.test_hour}h`}
                    {...{ boxDisplay, boxGap, widhtLabel }}
                  />
                  <DataField
                    label="ABERTURA DOS PORTÕES:"
                    value={`${proofLocationData?.candidate_allocation.gate_opening_time}h`}
                    {...{ boxDisplay, boxGap, widhtLabel }}
                  />
                  <DataField
                    label="FECHAMENTO DOS PORTÕES:"
                    value={`${proofLocationData?.candidate_allocation.gate_closing_time}h`}
                    {...{ boxDisplay, boxGap, widhtLabel }}
                  />
                </>
              )}
            </Section>

            {proofLocationData?.candidate_registration_card && (
              <Section title="INFORMAÇÕES IMPORTANTES">
                <TextXS dangerouslySetInnerHTML={{ __html: proofLocationData?.candidate_registration_card || '' }} />
              </Section>
            )}
            {showDownloadButton && (
              <Stack my={'10px'} align="center">
                <ProofLocationButton data={proofLocationData} isModeViewer />
              </Stack>
            )}
          </Stack>
        </>
      ) : (
        <Flex align="center" justify="center">
          <TextS>Sem dados</TextS>
        </Flex>
      )}
    </Box>
  );
};

interface ISectionProps {
  title: string;
  children: ReactNode;
}

const Section: React.FC<ISectionProps> = ({ title, children }) => (
  <Stack border="1px solid #7e7e7e" borderRadius="4px">
    <Box p={2} bg={'primaryColor'}>
      <TextXS color="white" textAlign="center" fontWeight="bold">
        {title}
      </TextXS>
    </Box>
    <Stack p={2}>
      <Stack>{children}</Stack>
    </Stack>
  </Stack>
);

interface IDataFieldProps {
  label: string;
  value: ReactNode;
  boxDisplay: string[];
  boxGap: string[];
  widhtLabel: string[];
}

const DataField: React.FC<IDataFieldProps> = ({ label, value, boxDisplay, boxGap, widhtLabel }) => (
  <Box display={boxDisplay} gap={boxGap}>
    <TextXS fontWeight="bold" w={widhtLabel}>
      {label}
    </TextXS>
    <TextXS>{value}</TextXS>
  </Box>
);

export default ProofLocationCard;
